import classNames from "classnames/bind";
import styles from './Config.module.css';
import ConfigVariable from "./ConfigVariable";

const cx = classNames.bind(styles);

function Config() {
    return (
        <div className={cx('config-wrapper')}>
            <div className={cx('main-config')}>
                <div className={cx('content-config')}>
                    <ConfigVariable />
                </div>
            </div>
        </div>
    )
}

export default Config;